import { inject, Injectable, signal } from '@angular/core';
import { CommonHttpService } from '../../common-http.service';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { catchError, finalize, from, Observable, switchMap, tap, throwError } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { IPurchasesResponse } from '../../../models/IPurchasesResponse';

@Injectable({
  providedIn: 'root'
})
export class MyPurchasesService {

  private httpService = inject(CommonHttpService);
  private http = inject(HttpClient);
  private oidcSecurityService = inject(OidcSecurityService);

  myPurchasesSignal = signal<IPurchasesResponse | null>(null);
  isLoading = signal<boolean>(true);
  isLoadingPatch = signal<boolean>(false);

  constructor() { }

  public getMyPurchases(filters: { page?: number; per?: number; sort?: string; }): Observable<IPurchasesResponse> {

    let url = `${environment.apiUrl}/v3/accounts/my-account/purchases`;

    // console.log('itemUrl', url)
    let params = new URLSearchParams();

    // Add parameters only if they exist
    if (filters.sort) params.append('sort', filters.sort);
    if (filters.page) params.append('page', filters.page.toString());
    if (filters.per) params.append('per', filters.per.toString());

    if (params.toString()) {
      url += `?${params.toString()}`;
    }

    return from(this.oidcSecurityService.checkAuth()).pipe(
      switchMap(authResult => {

        if (authResult.isAuthenticated) {
          let headers = new HttpHeaders();
          headers = headers.set('Authorization', `Bearer ${authResult.accessToken}`);
          return this.httpService.get<IPurchasesResponse>(url, undefined, headers);
        } else {
          return throwError(() => new Error('User is not authenticated'));
        }
      }),
      tap(response => {
        this.myPurchasesSignal.set(response);
        this.isLoading.set(false);
      }),
      catchError((error: HttpErrorResponse) => {
        const errorMsg = typeof error.error === 'string' ? error.error : 'Unknown Error';
        return throwError(() => new Error(errorMsg));
      })
    );
  }

  public patchCreditCard(purchaseId: number, cardId: number): Observable<any> {
    const url = `${environment.apiUrl}/v3/accounts/my-account/purchases/${purchaseId}`;

    const body = new HttpParams()
      .set('cardId', cardId);

    this.isLoadingPatch.set(true);

    return from(this.oidcSecurityService.checkAuth()).pipe(
      switchMap(authResult => {
        if (authResult.isAuthenticated) {
          const headers = new HttpHeaders()
            .set('Authorization', `Bearer ${authResult.accessToken}`)
            .set('Content-Type', 'application/x-www-form-urlencoded')
            .set('Accept', 'application/json');

          return this.http.patch<any>(url, body.toString(), { headers });
        } else {
          return throwError(() => new Error('unauthenticated user or expired token'));
        }
      }),
      finalize(() => {
        this.isLoadingPatch.set(false);
      }));
  }
}




